import { DOCUMENT } from '@angular/common';

export const PERMANENT_FEATURE_DETAIL = {
    EnvelopesActivity: 1001,
    RealTimeAuditTrail: 1002,
    Email: 1003,
    SMS: 1004,
    Templates: 1005,
    Documents: 1006,
    Questions: 1007,
    Rules: 1008,
    Variables: 1009,
    Applications: 1010,
    AddUser: 1011,
    UserAndGroupPermissions: 1012,
    TeamReports: 1013,
    SharedTemplates: 1014,
    TeamMemberDelegateSigner: 1015,
    SignerAttachments: 1016,
    DocumentVisibility: 1017,
    ShareableForms: 1018,
    BulkSend: 1019,
    ResponseSigningArea: 1020,
    QA: 1021,
    EmailNotification: 1022,
    SMSNotification: 1023,
    PersonalizedBranding: 1024,
    SignedDocuments: 1025,
    UnsignedDocuments: 1026,
    SequentialSending: 1027,
    MultiSending: 1028,
    UploadSign: 1029,
    SignLaterOption: 1030,
    DownloadOption: 1031,
    EmailReminders: 1032,
    SMSReminders: 1033,
    WhatsApp: 1034,
    CostPerMonth: 1035,
    CostPerAnnually: 1036,
    EnvelopesPerMonth: 1037,
    DocumentsPerEnvelope: 1038,
    ExceedMonthlyEnvelopeCharges: 1039,
    DocumentEmailSetting: 1040,
    EnvelopeCount: 1041,
    DocumentPlus: 2014,
    DocumentPlus2: 1006, // Duplicate of Documents feature code
    DOCUMENT: 1043,
    AiAssistenceEnable: 1054
} as const;

export type PermanentFeatureKey = keyof typeof PERMANENT_FEATURE_DETAIL;
export type PermanentFeatureCode = (typeof PERMANENT_FEATURE_DETAIL)[PermanentFeatureKey];

const LABEL_OVERRIDES: Partial<Record<PermanentFeatureKey, string>> = {
    RealTimeAuditTrail: 'Real-time Audit Trail',
    UserAndGroupPermissions: 'User & Group Permissions',
    TeamMemberDelegateSigner: 'Team Member Delegate Signer',
    ResponseSigningArea: 'Response Signing Area',
    SignLaterOption: 'Sign Later Option',
    DownloadOption: 'Download Option',
    EmailReminders: 'Email Reminders',
    SMSReminders: 'SMS Reminders',
    CostPerMonth: 'Cost Per Month',
    CostPerAnnually: 'Cost Per Annually',
    EnvelopesPerMonth: 'Envelopes Per Month',
    DocumentsPerEnvelope: 'Documents Per Envelope',
    ExceedMonthlyEnvelopeCharges: 'Exceed Monthly Envelope Charges',
    DocumentEmailSetting: 'Document Email Setting',
    EnvelopeCount: 'Envelope Count',
    DocumentPlus: 'Document Plus',
    DOCUMENT: 'DOCUMENT',
    QA: 'Q&A',
    SMS: 'SMS',
    Email: 'Email',
    WhatsApp: 'WhatsApp'
};

const prettify = (key: string) =>
    key.replace(/([A-Z])/g, ' $1').trim().replace(/\s+/g, ' ');

export const PERMANENT_FEATURES: { key: PermanentFeatureKey; code: number; label: string }[] =
    (Object.entries(PERMANENT_FEATURE_DETAIL) as [PermanentFeatureKey, number][])
        .map(([key, code]) => ({
            key,
            code,
            label: LABEL_OVERRIDES[key] ?? prettify(key)
        }))
        .sort((a, b) => a.code - b.code);

export function featureCode(key: PermanentFeatureKey): number {
    return PERMANENT_FEATURE_DETAIL[key];
}

export function featureKeyFromCode(code: number): PermanentFeatureKey | undefined {
    for (const k in PERMANENT_FEATURE_DETAIL) {
        if (PERMANENT_FEATURE_DETAIL[k as PermanentFeatureKey] === code) {
            return k as PermanentFeatureKey;
        }
    }
    return undefined;
}